<template>
<b-container class="text-left">
<h1>Abstracts</h1>
<div v-for="(abstract, idx) in abstracts" :key="idx">
  <div v-if="abstract.posterSubmission == 'I WILL submit an abstract' || abstract.posterSubmission =='I WILL submit an abstract and will enter it now'" class="abstract-item">
    <b-row>
        <b-col md="12">
            <span v-for="(author, id) in abstract.posterAuthors" :key="id">
                <span v-if="id!=0"> &#8226; </span>
                {{author.firstName}} {{author.lastName}}<span v-if="author.credentials">,</span> {{author.credentials}} <sup>{{author.locationIndex+1}}</sup>
            </span>
        </b-col>
    </b-row>
    <b-row>
        <b-col md="12">
            <span v-for="(location, ids) in abstract.posterPresenterLocations" :key="ids">
                <span v-if="ids!=0"> &#8226; </span>
                {{location}} <sup>{{ids+1}}</sup>
            </span>
        </b-col>
    </b-row>
    <b-row>
        <b-col md="12">
            <b>{{abstract.posterSubmissionTitle}}</b>
        </b-col>
    </b-row>
    <b-row>
        <b-col md="12">
            <b><i>{{abstract.posterSubmissionCategory}}</i></b>
        </b-col>
    </b-row>
    <b-row>
        <b-col md="12" v-html="abstract.posterSubmissionAbstract">
        </b-col>
    </b-row>
    <hr v-if="abstract.posterSubmission !== 'I am not submitting an abstract'">
  </div>
  </div>
</b-container>
</template>

<script>
import { db } from '../main'

export default {
  name: 'AbstractBook',
  data () {
    return {
      abstracts: [],
      userLocations: [],
      abstractAuthors: []
    }
  },
  firestore () {
    return {
      abstracts: db.collection('Registrations').where('conference.Id', '==', this.$router.currentRoute.params.conferenceId)
    }
  },
  beforeUpdate () {
    this.userLocations = []
    this.abstracts.forEach(element => {
      if (element.posterPresenterLocations.length > 0) {
        this.userLocations.push(element.posterPresenterLocations)
      }
    })
  }
}
</script>
<style scoped>
@media print {
    .abstract-item {
        page-break-after: always;
    }
    hr {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/AbstractBook.vue